<template>
  <div class="ly-tab">
    <ly-tabbar v-bind="options" v-model="selectedId">
      <ly-tab-item :key="index" v-for="(item, index) in items">
        <span slot="icon" v-if="options.fixBottom && item.icon">
          <i :class="item.icon"></i>
        </span>
        <span>{{ item[labelKey] }}</span>
      </ly-tab-item>
    </ly-tabbar>
  </div>
</template>

<script>
import LyTabbar from './tabbar'
import LyTabItem from './tab-item'

export default {
  name: 'LyTab',
  components: {
    LyTabbar,
    LyTabItem
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    items: {
      type: Array,
      default() {
        return []
      }
    },
    options: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      selectedId: this.value
    }
  },
  computed: {
    labelKey() {
      return this.options.labelKey || 'label'
    }
  },
  watch: {
    value(value) {
      this.selectedId = value
    },
    selectedId(value) {
      this.$emit('input', value)
      // this.$emit('change', this.items[value], value)
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Scroll/src/index.vue